import * as React from 'react';
import { UIText1 } from '@cian/ui-kit';
import { PictogramPlaceholderImages40 } from '@cian/ui-kit-design-tokens/pictograms';

import * as styles from './NoImage.css';

export const NoImage: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <PictogramPlaceholderImages40 display="block" />
      </div>
      <UIText1 color="gray60_100">Нет фото</UIText1>
    </div>
  );
};
